import React, { Fragment, useState } from 'react';
import { connect } from 'react-redux';
import { ReactSVG } from 'react-svg';
import classNames from 'classnames';

import { useCtxHistory } from 'hooks';
import { importStatic } from 'utils';

import { openSignUpModal } from '../../../store/modals/actions';
import { CLUSTER_HEADER_CATEGORY } from '../../../utils/constant';
import SearchBar from '../common/SearchBar';
import SubHeader from '../common/SubHeader';

import CareerClusterHeaderTitle from './CareerClusterHeaderTitle';

import subHeaderCalloutClasses from '../common/subHeaderCallout.module.css';

const CareerClusterHeader = ({
  subPageName,
  openSignUpModal,
  user,
  subTitle,
  subPageTextSmall,
  jobsCountForHeader,
  metadataH1,
  hideSearchBar = false,
  ...data
}) => {
  const history = useCtxHistory();
  const { title, layTitleDisplay, jobTitleArticle } = data.criteria;
  const { careerJobs, careerRemoteJobs } = data;
  const { locationDisplay, dynamicPageName } = data;
  const userLoggedIn = user && (user.isLoggedIn || user.emailAddr);
  const jobsCount =
    (subPageName === 'remote-jobs'
      ? careerRemoteJobs?.totalJobs
      : jobsCountForHeader || careerJobs?.totalJobs) || '';

  const signUpPopup = () => {
    const subPageSrc = subPageName === 'overview' ? 'cmp' : subPageName;
    const survey = '036';
    const src = `${subPageSrc}-page`;
    const query = {
      survey_step: 'step1',
      survey: survey,
      src,
    };
    openSignUpModal({
      ...query,
      popupType: 'career-callout-sign-up',
    });
    history.pushQuery(query);
  };

  const getCallout = () => {
    if (userLoggedIn) {
      return null;
    }
    return (
      <div className={subHeaderCalloutClasses['header-callout']}>
        <button className={subHeaderCalloutClasses['header-callout-button']} onClick={signUpPopup}>
          <ReactSVG src={importStatic('/ui-router/images/icon-notification.svg')} />
          <span>
            Get Alerts For <span className={subHeaderCalloutClasses['truncate-text']}>{title}</span>{' '}
            Jobs
          </span>
        </button>
      </div>
    );
  };
  const [pageTitle, setPageTitle] = useState('');

  return (
    <Fragment>
      <div className="job-title-search container d-flex flex-column-reverse flex-lg-row align-items-start">
        <CareerClusterHeaderTitle
          metadataH1={metadataH1}
          subPageName={subTitle || subPageName}
          title={layTitleDisplay || title}
          jobTitleArticle={jobTitleArticle}
          subPageTextSmall={subPageTextSmall}
          jobCount={jobsCount}
          getPageTitle={(_pageTitle) => setPageTitle(_pageTitle)}
        />
        {!hideSearchBar && (
          <SearchBar
            subPageName={subPageName}
            dynamicPageName={dynamicPageName}
            clusterCategory={CLUSTER_HEADER_CATEGORY.CAREER}
            jobLocation={locationDisplay}
            jobTitleArticle={jobTitleArticle}
            className={classNames('z-mt-12 z-mb-20 z-mb-lg-0 z-ml-lg-20', {
              'z-mt-lg-44': pageTitle.length > 40,
              'z-mt-lg-40': pageTitle.length <= 40,
            })}
          />
        )}
      </div>
      <div className="sub-header-container">
        <SubHeader callout={getCallout()} {...data} />
      </div>
      {/* Mobile callout */}
      {getCallout()}
    </Fragment>
  );
};

const mapDispatchToProps = {
  openSignUpModal,
};

export default connect(
  ({ user }) => ({
    user,
  }),
  mapDispatchToProps
)(CareerClusterHeader);
